/**
 * @file Scroll.js
 * @author Stanley Chen
 * @description Animated scroll indicator component that appears on the landing page
 * to encourage users to scroll down for more content
 */

import React, { useEffect } from 'react';
import { motion } from 'framer-motion';
import './Scroll.css';

const Scroll = () => {
  useEffect(() => {
    const handleScroll = () => {
      const indicator = document.querySelector('.scroll-indicator');
      if (window.scrollY > 100 && indicator) {
        indicator.classList.add('hidden');
      } else if (indicator) {
        indicator.classList.remove('hidden');
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className="scroll-indicator">
      <div className="arrow-container">
        <motion.div 
          className="arrow"
          animate={{ 
            y: [0, 10, 0],
            opacity: [0.7, 1, 0.7]
          }}
          transition={{ 
            duration: 1.8, 
            ease: "easeInOut", 
            repeat: Infinity,
            repeatType: "loop"
          }}
        >
          <span className="arrow-line left"></span>
          <span className="arrow-line right"></span>
        </motion.div>
      </div>
    </div>
  );
};

export default Scroll;